export default __webpack_public_path__ + "static/media/broker-login.819d062a.png";